import { FlyerLayoutAbstract } from './flyer-layout.abstract'
import moment from 'moment-timezone'

export default class Flyer_layout_card_circle_041LayoutModel extends FlyerLayoutAbstract {
  flourishes = [
    {
      name: 'purple_disco_bracket',
      left: 16,
      top: 256,
      width: 40,
      height: 149
    },
    {
      name: 'purple_disco_till',
      left: 205,
      top: 448,
      width: 12,
      height: 12
    },
    {
      name: 'diagonal_circle_black',
      left: 226,
      top: 180,
      height: 82,
      width: 82
    }
  ]

  textLayouts = {
    event_name_1: {
      top: 270,
      left: 69,
      size: 55,
      width: 239,
      height: 160
    },
    location_1: {
      top: 484,
      right: 12,
      left: 12,
      size: 12,
      width: 296,
      height: 16,
      align: 'right'
    },
    location_2: {
      top: 500,
      right: 12,
      left: 12,
      size: 12,
      width: 296,
      height: 16,
      align: 'right'
    }
  }

  dateLayouts = {
    date_1: {
      top: 440,
      left: 201,
      right: 12,
      daySize: 12,
      height: 28,
      width: 95,
      align: 'right'
    },
    date_2: {
      top: 190,
      left: 226,
      daySize: 46,
      height: 60,
      width: 82,
      widthAlign: 'center'
    },
    date_3: {
      top: 239,
      left: 226,
      daySize: 14,
      height: 14,
      width: 82,
      widthAlign: 'center'
    }
  }

  constructor(flyerDesign, eventData) {
    super(flyerDesign, eventData)
    this.init()
  }

  getLocationText2() {
    const defaultText2 = this.getDefaultText2()
    const defaultText3 = this.getDefaultText3()
    if (defaultText2) {
      if (defaultText3) {
        return `${defaultText2}\n${defaultText3}`
      }
      return `${defaultText2}`
    }

    if (defaultText3) {
      return `${defaultText3}`
    }

    return null
  }

  getDateTexts() {
    const startDate = this.eventData.starts_at
    const timeZone = this.eventData.timezone || 'UTC'

    const date1 = this.dateLayouts.date_1
    const date2 = this.dateLayouts.date_2
    const date3 = this.dateLayouts.date_3

    const safeDate1Color = this.dateProps.date1Props?.color?.replace('0x', '#') || '#cccccc'
    const safeDate1Font = this.dateProps.date1Props?.font?.replace(/\s+/g, '-') || 'Arial'
    const safeDate2Color = this.dateProps.date2Props?.color?.replace('0x', '#') || '#FFFFFF'
    const safeDate3Color = this.dateProps.date3Props?.color?.replace('0x', '#') || '#FFFFFF'

    let dates = []
    if (!startDate) return { type: 'date', dates }

    const dateInformation = this.formatDates({
      day: 'MMM Do h:mmA',
      time: 'h:mmA'
    })

    const start = moment.tz(startDate, timeZone)

    const { formattedStart, formattedEnd } = dateInformation

    const dayLabel = start.format('D')

    const monthLabel = start.format('MMM').toUpperCase()

    dates.push({
      text: `${formattedStart}\n${formattedEnd}`,
      align: date1.align,
      width: date1.width,
      height: date1.height,
      left: date1.left,
      right: date1.right,
      top: date1.top,
      color: safeDate1Color,
      font: safeDate1Font,
      size: date1.daySize
    })

    dates.push({
      text: dayLabel,
      align: date2.align,
      width: date2.width,
      height: date2.height,
      left: date2.left,
      top: date2.top,
      color: safeDate2Color,
      font: 'Arial',
      size: date2.daySize,
      widthAlign: date2.widthAlign || 'center'
    })

    dates.push({
      text: monthLabel,
      align: date3.align,
      width: date3.width,
      height: date3.height,
      left: date3.left,
      top: date3.top,
      color: safeDate3Color,
      font: safeDate1Font,
      size: date3.daySize,
      widthAlign: date3.widthAlign
    })

    return { type: 'date', dates }
  }
}
